module.exports = __webpack_public_path__ + "img/Hawaiian_Poke_Wrap_Ahi_Tuna.7e1e4216.jpg";